const testimonialsConfig: {
  text: {
    en: string;
    es: string;
    pt: string;
  };
  author: {
    name: string;
    title: {
      en: string;
      es: string;
      pt: string;
    };
  };
}[] = [
  {
    text: {
      en:
        'omegaUp has been the platform that I have used the most for training, since every test used for the State, National and International qualifiers happened in omegaUp.',
      es:
        'omegaUp ha sido la plataforma que he usado a lo largo de mi preparación, ya que todos los exámenes selectivos estatales nacionales e internacionales son realizados ahí.',
      pt:
        'omegaUp tem sido a plataforma que eu mais usei para treinamento, pois todas as provas utilizadas para as eliminatórias estaduais, nacionais e internacionais ocorreram no omegaUp.',
    },
    author: {
      name: 'Mariola',
      title: {
        en: 'Gold Medal Mexican Olympiad in Informatics, 2017',
        es: 'Medalla de Oro Olimpiada Mexicana en Informática, 2017',
        pt: 'Medalha de Ouro da Olimpíada Mexicana em Informática, 2017',
      },
    },
  },
  {
    text: {
      en:
        'omegaUp helped me a lot! I trained like crazy and started to feel how my level, little by little, was improving, how doors opened to me, how others started to as me "hey, can you help us train?"',
      es:
        '¡omegaUp me ayudó mucho! Me entrené como un loco y comencé a sentir cómo mi nivel, poco a poco, estaba mejorando, cómo se abrieron las puertas para mí, cómo otros comenzaron a decirme "oye, ¿puedes ayudarnos a entrenar?"',
      pt:
        'omegaUp me ajudou muito! Treinei como um louco e comecei a sentir como meu nível, aos poucos, estava melhorando, como as portas se abriam para mim, como os outros começaram a ser como eu "ei, você pode nos ajudar a treinar?"',
    },
    author: {
      name: 'Diego',
      title: {
        en: 'Participant in Mexican Olympiad in Informatics, 2015',
        es: 'Participante en la Olimpiada Mexicana de Informática, 2015',
        pt: 'Participante da Olimpíada Mexicana de Informática, 2015',
      },
    },
  },
  {
    text: {
      en:
        'omegaUp has been witness to both moments of frustration and moments of complete happiness. I am a participant at the Mexican Olympiad in Informatics and I have to admit that qualifying to team from my state last year was an oddisey. It was in omegaUp, where I experience that last test that decided everything. Once it was over, I got the news I had made it, I was going to the national! I will never forget that moment, and omegaUp was a part of it.',
      es:
        'omegaUp ha sido testigo tanto de momentos de frustración como de momentos de completa felicidad. Soy participante de la Olimpiada mexicana en informática y tengo que admitir que calificar para el equipo de mi estado el año pasado fue una enfermedad extraña. Fue en omegaUp, donde experimenté esa última prueba que decidió todo. Una vez que terminó, recibí la noticia de que había llegado, ¡me iba al nacional! Nunca olvidaré ese momento, y omegaUp fue parte de él.',
      pt:
        'omegaUp foi testemunha de momentos de frustração e momentos de completa felicidade. Sou participante da Olimpíada Mexicana de Informática e tenho que admitir que me qualificar para a equipe do meu estado no ano passado foi um acaso. Foi no omegaUp, onde experimentei o último teste que decidiu tudo. Quando acabou, recebi as notícias que tinha feito, estava indo para o nacional! Nunca esquecerei esse momento, e o omegaUp fez parte dele.',
    },
    author: {
      name: 'André',
      title: {
        en: 'Gold Medal Mexican Olympiad in Informatics',
        es: 'Medalla de Oro Olimpiada Mexicana en Informática',
        pt: 'Medalha de Ouro da Olimpíada Mexicana em Informática',
      },
    },
  },
];

export default testimonialsConfig;
